import { Header } from '@/components/overrides/Header';
import {
  BackgroundImage,
  Footer,
  ListingAppContext,
  ListingHeading,
  UserPhoto,
} from '@showclix-shared/ListingComponents';
import { getXssFilter } from '@showclix-shared-util/xssFilter';
import {
  FunctionComponent,
  PropsWithChildren,
  ReactNode,
  useContext,
  useMemo,
} from 'react';
import { useAppData } from '@/contexts/AppData';

export interface BaseLayoutUiConfig {
  bannerImage: string;
  profileImage: string;
  title: string;
  content: string;
}

export interface BaseLayoutProps {
  config: BaseLayoutUiConfig;
  headerContent?: ReactNode;
}

export const BaseLayout: FunctionComponent<
  PropsWithChildren<BaseLayoutProps>
> = ({ children, config, headerContent }) => {
  const { uiConfig, partnerLinks, messages } = useAppData();
  const { t } = useContext(ListingAppContext);

  const processedMessages = useMemo(() => {
    const resultMessages = [
      ...(messages.finalMessages || []).map((m) => t(m)),
      ...(messages.customMessages || []),
    ];

    return getXssFilter().process(resultMessages.join('<br />'));
  }, [messages]);

  return (
    <>
      <Header>{headerContent}</Header>
      <BackgroundImage image={config.bannerImage} />
      <div className="org-listing__main">
        <div className="org-listing__main__container org-listing__container">
          <UserPhoto image={config.profileImage} name={config.title} isMulti />
          <ListingHeading
            primaryText={config.title}
            secondaryText={config.content}
            className="listing__user-text"
          />
          {children}
        </div>
      </div>
      <Footer
        copyrightName={uiConfig.listings.title}
        logo={uiConfig.images.footer_logo}
        tosUrl={partnerLinks.tosUrl}
        contactUrl={partnerLinks.contactUrl}
        privacyUrl={partnerLinks.privacyUrl}
        className="multilisting-footer"
        messages={
          processedMessages && (
            <div
              className="footer-messages"
              dangerouslySetInnerHTML={{ __html: processedMessages }}
            />
          )
        }
      />
    </>
  );
};
